module.exports = __webpack_public_path__ + "img/blue_079.e1c8c4cc.png";